//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The payment type id.
*
* 
*  * UNDEFINED value: 0 - Payment-Methode noch nicht gesetzt / undefined (experimental) 
*  * ADVANCE_PAYMENT value: 1 - Vorauskasse / Überweisung / bank transfer (CLARIFY WORDING) 
*  * CREDIT_CARD value: 2 - Kreditkarte / credit card 
*  * DIRECT_DEBIT value: 3 - Bankeinzug / direct debit 
*  * PAYPAL value: 4 - PayPal 
*  * INVOICE value: 5 - Rechnung 
*  * INSTANT_TRANSFER value: 6 - Sofortüberweisung 
*  * STUBHUB value: 7 - StubHub 
*  * IDEAL value: 8 - iDEAL 
*  * EPS_TRANSFER value: 9 - eps Online-Überweisung 
*  * CREDIT_CARD_2 value: 10 - Kreditkarte / (NEEDED?) (deprecated: use CREDIT_CARD) 
*  * SEPA_DIRECT_DEBIT value: 13 - SEPA Lastschrift 
*  * GIROPAY value: 15 - giropay 
*  * GOOGLE_PAY value: 16 - Google Pay 
*  * APPLE_PAY value: 17 - Apple Pay 
*/
@Serializable
enum class PaymentTypeId(val value: kotlin.Int) {

    @SerialName(value = "0")
    UNDEFINED(0),

    @SerialName(value = "1")
    ADVANCE_PAYMENT(1),

    @SerialName(value = "2")
    CREDIT_CARD(2),

    @SerialName(value = "3")
    DIRECT_DEBIT(3),

    @SerialName(value = "4")
    PAYPAL(4),

    @SerialName(value = "5")
    INVOICE(5),

    @SerialName(value = "6")
    INSTANT_TRANSFER(6),

    @SerialName(value = "7")
    STUBHUB(7),

    @SerialName(value = "8")
    IDEAL(8),

    @SerialName(value = "9")
    EPS_TRANSFER(9),

    @SerialName(value = "10")
    CREDIT_CARD_2(10),

    @SerialName(value = "13")
    SEPA_DIRECT_DEBIT(13),

    @SerialName(value = "15")
    GIROPAY(15),

    @SerialName(value = "16")
    GOOGLE_PAY(16),

    @SerialName(value = "17")
    APPLE_PAY(17);

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value.toString()

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is PaymentTypeId) "$data" else null

    /**
    * Returns a valid [PaymentTypeId] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): PaymentTypeId? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

